/**
 * Owner: Haselton Baker Risk Group, LLC
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/30/18
 * Copyright All Rights Reserved
 */

import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import token from './tokenReducer';
import users from './usersReducer';

const rootReducer = combineReducers({
  form,
  token,
  users,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./js/reducers/index.js